export const getCurrentAppRoute = state => state.getIn(['app', 'route']); // eslint-disable-line import/prefer-default-export

export const getAppIsRTL = state => state.getIn(['app', 'isRTL']);

export const getAppIsBlacklisted = state => state.getIn(['app', 'isBlackListed']);

export const isAppOnline = state => state.getIn(['app', 'online']);
